/**
 * SASADM-0154 — the brand-theme contract §4 colour roles the Theme tab edits.
 */

export const STATUS_SEEDS = ['success', 'warning', 'error', 'info'] as const;

/**
 * Contract §4 roles grouped for the overrides table (one group shown at a
 * time), in contract order — minus the `hover`/`selected` state layers ("go" §4).
 */
export const OVERRIDE_GROUPS: { id: string; roles: string[] }[] = [
  { id: 'canvas', roles: ['bg', 'surface', 'surface2', 'surfaceRaised'] },
  { id: 'text', roles: ['text', 'text2', 'text3', 'link'] },
  { id: 'lines', roles: ['line', 'lineStrong', 'focusRing'] },
  {
    id: 'brand',
    roles: [
      'brand',
      'brandHover',
      'brandInk',
      'brandSoft',
      'brandDeep',
      'brandDeepInk',
      'brandDeepMuted',
    ],
  },
  { id: 'accent', roles: ['accent', 'accentHover', 'accentInk', 'accentSoft'] },
  { id: 'appBar', roles: ['appBar', 'appBarInk'] },
  ...STATUS_SEEDS.map((s) => ({
    id: s,
    roles: [`${s}Fg`, `${s}Text`, `${s}Fill`, `${s}Ink`, `${s}Soft`],
  })),
  { id: 'money', roles: ['moneyPositive', 'moneyNegative', 'moneyNegativeWash'] },
  { id: 'highlight', roles: ['highlight'] },
];

export const OVERRIDE_ROLES: string[] = OVERRIDE_GROUPS.flatMap((g) => g.roles);
